import { createApiService } from "@/core/api/apiService";
import type { FeedbackReceiptDto, SendFeedbackDto } from "../types/feedbackTypes";

export function createFeedbackApiService() {
  const api = createApiService("feedback");

  return {
    send: (dto: SendFeedbackDto): Promise<FeedbackReceiptDto> => api.post<FeedbackReceiptDto>("/", dto),
  };
}

export const feedbackApiService = createFeedbackApiService();
